<template>
    <q-layout view="hHh lpR fFf">
        <q-header  v-if="logueado">
            <q-toolbar style="min-height:60px">
                <q-btn flat dense round @click="irInicio" style="background:rgba(255,255,255,.12)">
                    <q-icon name="mdi-home" color="white" size="23px" />
                </q-btn>
                <q-toolbar-title>
                    <span style="font-size:16px;font-weight:500;letter-spacing:.01em">
                        AUTOCONTA   
                        </span>
                    </q-toolbar-title>
                <div class="rfc-chip" style="font-size:16px;">{{ $store.state.usuario.rfc }}</div>

                <q-btn flat round dense class="header-btn" @click="drawerEmpresas = !drawerEmpresas">
                    <q-icon name="mdi-domain" color="white" size="23px" />
                    <q-tooltip content-style="font-size:13px">Empresas</q-tooltip>
                </q-btn>

                <q-btn flat round dense class="header-btn" @click="drawerPerfil = !drawerPerfil">
                    <q-icon name="mdi-account" color="white" size="23px" />
                    <q-tooltip content-style="font-size:13px">Perfil</q-tooltip>
                </q-btn>
            </q-toolbar>
        </q-header>

<!-- DRAWER DERECHO -->
<q-drawer :width="320" v-model="drawerPerfil" behavior="mobile" side="right" bordered v-if="logueado"
            style="background:#fff">
            <drawerPerfil />
        </q-drawer>

    <!-- DRAWER EMPRESAS -->
    <q-drawer :width="320" v-model="drawerEmpresas" behavior="mobile" side="right" bordered v-if="logueado"
                style="background:#fff">
                <drawerEmpresas />
            </q-drawer>

        <!-- DRAWER IZQUIERDO -->
        <q-drawer v-model="leftDrawerOpen" show-if-above :mini="miniState" @mouseover="miniState = false"
            @mouseout="miniState = true" :width="320" :breakpoint="500" bordered content-class="bg-purple-1">
            <q-scroll-area class="fit" :horizontal-thumb-style="{ opacity: 0 }">
                <q-list padding>

                    <q-item active clickable v-ripple @click="irBalanza">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-scale-balance" />
                        </q-item-section>
                        <q-item-section>
                        {{ $t('reportes.sidebar.balanza') }}
                    </q-item-section>
                    </q-item>

                    <!-- <q-item active clickable v-ripple @click="irBalanzaSucursal">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-scale-balance" />
                        </q-item-section>
                        <q-item-section>
                            Balanza por Sucursal
                        </q-item-section>
                    </q-item> -->

                    <q-separator />

                    <q-item active clickable v-ripple @click="irEstadoResultados">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-file-chart" />
                        </q-item-section>
                        <q-item-section>
                        {{ $t('reportes.sidebar.estadoResultados') }}
                    </q-item-section>
                    </q-item>

                    <q-separator />

                    <q-item active clickable v-ripple @click="irEstadoSituacionFinanciera">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-file-chart" />
                        </q-item-section>
                        <q-item-section>
                        {{ $t('reportes.sidebar.estadoSituacionFinanciera') }}
                    </q-item-section>
                    </q-item>

                    <q-separator />

                    <!-- <q-item active clickable v-ripple @click="irEstadoSituacionFinancieraAnual">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-file-chart" />
                        </q-item-section>
                        <q-item-section>
                            Estado de Situación Financiera Anual
                        </q-item-section>
                    </q-item>

                    <q-separator /> -->

                    <q-item active clickable v-ripple @click="irLibroDiario">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-book-open-variant" />
                        </q-item-section>
                        <q-item-section>
                        {{ $t('reportes.sidebar.libroDiario') }}
                    </q-item-section>
                    </q-item>

                    <q-separator />

                    <q-item active clickable v-ripple @click="irRelacionesFinancieras">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-file-sign" />
                        </q-item-section>
                        <q-item-section>
                        {{ $t('reportes.sidebar.relacionesFinancieras') }}
                    </q-item-section>
                    </q-item>

                    <q-separator />

                    <q-item active clickable v-ripple @click="irMayores()">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-book" />
                        </q-item-section>
                        <q-item-section>
                        {{ $t('reportes.sidebar.mayores') }}
                    </q-item-section>
                    </q-item>

                    <q-separator />

                </q-list>
            </q-scroll-area>
        </q-drawer>

        <q-page-container>
            <router-view />
        </q-page-container>

        <!-- <q-footer style="height: 30px;" bordered class="bg-dark text-white">
            <q-toolbar>
                <q-toolbar-title>
                </q-toolbar-title>
            </q-toolbar>
        </q-footer> -->
    </q-layout>
</template>

<script>
import { ref } from 'vue'
import axios from "axios";
import drawerPerfil from "../DrawerPerfil/DrawerPerfil.vue"

import drawerEmpresas from '../DrawerEmpresas/DrawerEmpresas.vue'

export default {

    name: 'MainLayout',
    components: {
        drawerPerfil, drawerEmpresas
    },
    data() {
        return {
            drawerPerfil: false,
            isDarkMode: false,
            leftDrawerOpen: false,
            drawer: false,
            miniState: true,
            drawerEmpresas: false,

        }
    },

    watch: {
        isDarkMode(val) {
            this.$q.dark.set(val);
        }
    },
    computed: {
        logueado() {
            return this.$store.state.usuario;
        },
        token() { return this.$store.state.empresaStore },

    },
    created() {
    },
    methods: {
        irInicio() {
            this.$router.push({ name: 'Home' })
        },
        irBalanza() {
            this.$router.push({ name: 'Balanza' })
        },
        irEstadoResultados() {
            this.$router.push({ name: 'EstadoResultados' })
        },
        irEstadoSituacionFinanciera() {
            this.$router.push({ name: 'EstadoSituacionFinanciera' })
        },

        irEstadoSituacionFinancieraAnual() {
            this.$router.push({ name: 'EstadoSituacionFinancieraAnual' })
        },

        irLibroDiario() {
            this.$router.push({ name: 'LibroDiario' })
        },

        irRelacionesFinancieras() {
            this.$router.push({ name: 'RelacionesFinancieras' })
        },

        irMayores() {
            this.$router.push({ name: 'Mayores' })
        },
        irBalanzaSucursal(){
            this.$router.push({ name: 'BalanzaSucursal' })
        }
    }
}
</script>
